<template>
  <div class="m-0 dbozone-font" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-guardianWealth">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`${lang} -guardianWealth`">{{ $t('guardianWealth.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_9.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2 mt-4">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">{{$t('guardianWealth.paytable.symtable_wild1')}}
            <br>{{$t('guardianWealth.paytable.symtable_wild2')}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex ml-2 mt-4">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">{{$t('guardianWealth.paytable.symtable_wild1')}}
            <br>{{$t('guardianWealth.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[7][4]}}
            <br>{{'4 - ' + paytable[7][3]}}
            <br>{{'3 - ' + paytable[7][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][4]}}
            <br>{{'4 - ' + paytable[6][3]}}
            <br>{{'3 - ' + paytable[6][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_5.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][4]}}
            <br>{{'4 - ' + paytable[5][3]}}
            <br>{{'3 - ' + paytable[5][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_4.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][4]}}
            <br>{{'4 - ' + paytable[4][3]}}
            <br>{{'3 - ' + paytable[4][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][4]}}
            <br>{{'4 - ' + paytable[3][3]}}
            <br>{{'3 - ' + paytable[3][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][4]}}
            <br>{{'4 - ' + paytable[2][3]}}
            <br>{{'3 - ' + paytable[2][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[1][4]}}
            <br>{{'4 - ' + paytable[1][3]}}
            <br>{{'3 - ' + paytable[1][2]}}
          </span>
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/guardianWealth/1/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-3 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[0][4]}}
            <br>{{'4 - ' + paytable[0][3]}}
            <br>{{'3 - ' + paytable[0][2]}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column nav-guardianWealth mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -guardianWealth`">{{ $t('guardianWealth.freespin') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-freespin1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-freespin2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-freespin3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-freespin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-freespin5') }}</span>
      </div>

      <div class="d-flex flex-column nav-guardianWealth mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -guardianWealth`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/guardianWealth/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-guardianWealth mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`${lang} -guardianWealth`">{{ $t('guardianWealth.line') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class=" m-0 text-bet-line" :class="`-${lang}`">{{ $t('guardianWealth.text-line1') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-line2') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-line3') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/guardianWealth/line.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1 justify-content-center">
        <span class=" m-0 text-sub-center" :class="`-${lang}`">{{ $t('guardianWealth.text-line4') }}</span>
      </div>
      <div class="d-flex p-2 mb-5">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('guardianWealth.text-line5') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-guardianWealth',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.nav-guardianWealth {
  background-color: #1674cc;
  border-radius: 5px 5px 5px 5px;
}

.text-sub-line-gh {
  color: #ffffff;
  font-size: 2.5rem;
  text-align: left;
}

.icon-paytable {
  width: 100%;
}

.content {
  background: #112139;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>